export enum CustomCollectionsIds {
  search = "-1",
  favorites = "-2",
  nearby = "-3",
}
